import { ConfigurationGateway } from './configuration-gateway.interface';

const baseUrl = 'gk/configurations';
export class HttpConfigurationGateway implements ConfigurationGateway {
  getConfigurationsByProject(args: { projectId: string; groupName: string }) {
    return {
      url: `${baseUrl}/${args.projectId}`,
      method: 'GET',
      params: {
        groupName: args.groupName,
      },
    };
  }

  patchConfigurations(args: { projectId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.projectId}`,
      method: 'PATCH',
      data: { configurations: args.data },
    };
  }

  getConfigurationDifference(args: { configId: string; editableConfig: any }) {
    return {
      url: `${baseUrl}/${args.configId}/calcul-difference`,
      method: 'POST',
      data: { editableConfig: args.editableConfig },
    };
  }

  getConfigurationFormatToDoc(args: { configurations: any }) {
    return {
      url: `${baseUrl}/format-for-doc`,
      method: 'POST',
      data: { configurations: args.configurations },
    };
  }

  getTempConfigurationsPrice(args: { projectId: string; configurations: any }) {
    return {
      url: `${baseUrl}/${args.projectId}/temp-configuration-price`,
      method: 'POST',
      data: { configurations: args.configurations },
    };
  }
}
